import React from 'react'
import SupplierDetails from '../Components/Admin/SupplierDetails'

function SupplierDetailsPage() {
  return (
    <div className="supplier-details-page min-h-screen bg-[#f8fafc]">
      <SupplierDetails />
    </div>
  )
}

export default SupplierDetailsPage
